'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import { ProfileListing } from 'marketplace-ui-solutions-core/records/ProfileListing';
import { getInAppReviewLink } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const I18N_BASE = 'ecosystem-marketplace-solutions-ui.profile.reviews';
const WriteReviewButton = ({
  hasEditableReview,
  isPreview,
  isPublicApp,
  profileListing,
  reviewButtonRef,
  setWizardOpen,
  size,
  unreviewableReason
}) => {
  const {
    slug
  } = profileListing;
  const isReviewable = isPublicApp || !unreviewableReason || unreviewableReason !== 'ReviewError.EDIT_PENDING' && hasEditableReview;
  let buttonProps;
  if (isPreview) {
    buttonProps = {};
  } else {
    if (isPublicApp) {
      buttonProps = {
        href: getInAppReviewLink(slug)
      };
    } else {
      buttonProps = {
        onClick: () => setWizardOpen(true)
      };
    }
  }
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `marketplace-ui-reviews.error.${unreviewableReason}`
    }),
    disabled: isReviewable,
    children: /*#__PURE__*/_jsx(UIButton, Object.assign({
      disabled: !isReviewable,
      use: hasEditableReview ? 'tertiary-light' : 'tertiary',
      size: size,
      tabIndex: -1
    }, buttonProps, {
      children: /*#__PURE__*/_jsx("div", {
        tabIndex: 0,
        ref: reviewButtonRef,
        role: "button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_BASE}.write.${hasEditableReview ? 'edit' : 'button'}`
        })
      })
    }))
  });
};
WriteReviewButton.propTypes = {
  isPreview: PropTypes.bool.isRequired,
  isPublicApp: PropTypes.bool.isRequired,
  profileListing: PropTypes.instanceOf(ProfileListing),
  reviewButtonRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),
  setWizardOpen: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired,
  unreviewableReason: PropTypes.string
};
WriteReviewButton.defaultProps = {
  size: 'sm'
};
export default WriteReviewButton;